import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { Previlege } from "./Previlege";
import { Report } from "./Report";

interface UserConfigProps {
    open: boolean;
    onClose: () => void;
  }
export const UserRoleConfig:React.FC<UserConfigProps>=React.memo(({ open,
    onClose,})=>{
        const methods = useForm();
        const { handleSubmit, control, register } = methods;
      const tabs = [
        { label: "Previlege", content:<Previlege/> },
        { label: "Report", content:<Report/> },
      ];
      const onSubmit = async (data: any) => {
        debugger;
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };
return (
    <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
       <Dialog   open={open}
       onClose={onClose}
       fullWidth={true}
       maxWidth="md"
       PaperProps={{
         style: {
           backgroundColor: 'whitesmoke',
           width: '70vw',
           height: '80vh',
           left:100
         },
       }}>
   <DialogTitle>
             <Grid
               display="flex"
               justifyContent="space-between"
               alignItems="center"
             >
               <Typography variant="h6" color="blue">
                 User Roles
               </Typography>
               <IconButton onClick={onClose}>
                 <WSIcons.CloseIcon sx={{ color: "black" }} />
               </IconButton>
             </Grid>
           </DialogTitle>
           <Divider />
           <DialogContent>
           <Grid item>
          <Grid
            sx={{
              border: '1px solid #ccc', 
            height:"60rem",
              p: 2,                     
            }}
          >
            <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />
          </Grid>
        </Grid>
   
           
   
         </DialogContent>
         <DialogActions>
         <Grid
  container
  sx={{
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center", 
  }}
>
  <Grid item>
    <Button
      variant="outlined"
      sx={{ color: "black", borderColor: "black" }}
    >
      Export to XLS
    </Button>
  </Grid>
  <Grid
    item
    sx={{
      display: "flex", 
      gap: "1rem", 
    }}
  >
    <Button
      variant="outlined"
      sx={{ color: "black", borderColor: "black" }}
    >
      Save
    </Button>
    <Button
      variant="outlined"
      sx={{ color: "black", borderColor: "black" }}
      onClick={handleSubmit(onSubmit)}
    >
      Close
    </Button>
  </Grid>
</Grid>

         </DialogActions>
       </Dialog>
       </form>
       </FormProvider>
     );
})